export default "__VITE_ASSET__B1u_Bh7T__"